(function(){
'use strict';

var OCCASION_CONFIG = {
  any:         { label:'Any Occasion',  colKeywords:[], tagKeywords:[] },
   christmas:        { label:'Christmas Hampers',          colKeywords:['all-christmas-hampers-2026'],       tagKeywords:[] },
  winter:        { label:'Winter',          colKeywords:['autumn-winter-hampers','winter'],       tagKeywords:['AUTUMN NEW'] },
  baby:     { label:'Baby Hampers',      colKeywords:[ 'baby-hampers'],
                                        tagKeywords:[] },
  baskets:    { label:'Hamper Baskets',      colKeywords:['gift-basket'],
                                        tagKeywords:[''] },
  birthday:    { label:'Birthday',      colKeywords:['trending-birthday-hampers', 'baby-birthday-hampers', 'birthday-hampers-for-kids', 'milestone-birthdays'],     tagKeywords:[] },
  anniversary: { label:'Anniversary',   colKeywords:['anniversary-hampers'],  tagKeywords:['ANNIVERSARY PRODUCTS'] },
  thankyou:    { label:'Thank You',     colKeywords:['thank-you-hampers', 'thank-you-corporate-hampers'],
                                        tagKeywords:[''] },
  wedding:     { label:'Wedding',       colKeywords:['wedding-hampers', 'engagement-hampers', 'groomsman-best-man-hampers' , 'bridesmaid-maid-of-honour-hampers'],
                                        tagKeywords:[] },
  newbaby:     { label:'Baby Shower',      colKeywords:[ 'baby-shower-gifts'],
                                        tagKeywords:[] },
  getwell:     { label:'Get Well',      colKeywords:['get-well-soon-hampers'],
                                        tagKeywords:[''] },
  congrats:    { label:'Congrats',      colKeywords:['congrats-hampers'],
                                        tagKeywords:[''] }
};

var ALL_OCCASIONS = ['any','christmas','baskets','baby','birthday','anniversary','thankyou','wedding','newbaby','getwell','congrats'];

var RECIPIENT_OPTIONS = [
  { val:'anyone',  label:'Anyone',   kws:[] },
  { val:'babyboy',  label:'Baby Boy',   kws:['Baby Boy'] },
  { val:'babygirl',  label:'Baby Girl',   kws:['Baby Girl'] },
  { val:'unisex',  label:'Unisex Baby',   kws:['Unisex Baby'] },
  { val:'forhim',  label:'For Him',  kws:['for him','for-him','forhim','him','men','man','male','groom','groomsman','groomsmen','dad','father','husband','boyfriend','brother'] },
  { val:'forher',  label:'For Her',  kws:['Brides Maid','Bride & Bride', 'bride', 'Bride & Groom', 'for her','for-her','forher','her','women','woman','female','bride','bridesmaid','mum','mum','mom','wife','girlfriend','sister','daughter'] },
   { val:'toshare', label:'Hampers to Share', kws:['Sharing'] },
  { val:'forkids', label:'For Kids', kws:['CHRISTMAS FOR KIDS', 'Gifts for Kids', 'Gifts for Kids', 'Kids Hampers', 'for kids','forkids','kids','children'] }
];

var BUDGET_OPTIONS = [
  { val:'anyprice', label:'Any Price',   min:0,   max:999999 },
  { val:'under99',  label:'Under $99',   min:0,   max:99.99 },
  { val:'b100149',  label:'$100 - $149', min:100, max:149.99 },
  { val:'b150199',  label:'$150 - $199', min:150, max:199.99 },
  { val:'over200',  label:'$200+',       min:200, max:999999 }
];

var PER = 4;

/* 
   HIDDEN TAGS / TYPES
 */
var HIDDEN_TAGS = [
  'import gba','easify box builder','searchanise_ignore','personalize','cyo',
  'general-bundles','extras products','cyo-personalise','cyo-snacks',
  'cards','cyo-beverage','basket designs','extras','extranew',
  'extra bundles','extra','content 18','cyo sweets'
];
var HIDDEN_TYPES = ['CYO Hamper', 'content extras','corporate branding','box builder','extras - cookies','sleeves','extras - christmas'];

var ICONS = {
  'any-occ':   '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><rect width="24" height="24" rx="12" fill="#333"/><path d="M12 6l1.5 3.5H17l-2.8 2 1 3.5L12 13l-3.2 2 1-3.5L7 9.5h3.5z" stroke="white" stroke-width="1.2" stroke-linejoin="round"/></svg>',
  baskets:      '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <rect width="24" height="24" rx="12" fill="#333"/> <path fill-rule="evenodd" clip-rule="evenodd" d="M4 10.0265C4.00395 9.73613 4.20233 9.51188 4.48479 9.45725C5.36921 9.45402 6.25327 9.44971 7.13696 9.44432C7.85715 8.37806 8.57374 7.30892 9.28637 6.23691C9.75392 5.64072 10.6387 6.28327 10.2143 6.91613C9.66731 7.73694 9.11998 8.55738 8.5723 9.37783C8.56367 9.40155 8.53025 9.4188 8.55397 9.44324C10.8845 9.45402 13.215 9.45402 15.5456 9.4436C15.5488 9.43893 15.5517 9.43425 15.5549 9.42958C15.0054 8.59584 14.4531 7.76425 13.8971 6.93446C13.4475 6.31238 14.3176 5.6285 14.8128 6.23691C15.5262 7.30856 16.2424 8.3777 16.9622 9.44396C17.8463 9.44935 18.73 9.45402 19.6144 9.45725C20.2677 9.58483 20.258 10.5009 19.5788 10.5993C19.3747 10.6019 19.1709 10.6022 18.9668 10.6008C18.9309 10.6004 18.9089 10.618 18.901 10.6529C18.7472 12.4623 18.5934 14.2718 18.44 16.0812C18.2786 16.8858 17.631 17.4519 16.8113 17.4997C13.6847 17.5015 10.5582 17.5022 7.43165 17.5015C6.57095 17.5212 5.85149 16.9556 5.66713 16.1154C5.65311 16.0083 5.63946 15.9015 5.6258 15.7944C5.48313 14.0806 5.34046 12.3667 5.19815 10.6529C5.19024 10.618 5.16832 10.6004 5.13238 10.6008C4.6537 10.6144 4.03881 10.678 4 10.0265ZM8.59961 12.3984C8.59674 13.3697 8.59961 14.3411 8.6086 15.3122C8.75989 15.9331 9.60514 15.9321 9.74349 15.2906C9.75284 14.2657 9.75176 13.2407 9.74026 12.2158C9.57207 11.5057 8.55289 11.653 8.59961 12.3984ZM11.4746 12.3984C11.4717 13.3697 11.4746 14.3411 11.4836 15.3122C11.6349 15.9331 12.4801 15.9321 12.6185 15.2906C12.6278 14.2657 12.6267 13.2407 12.6152 12.2158C12.4471 11.5057 11.4279 11.653 11.4746 12.3984ZM14.3496 12.3984C14.3467 13.3697 14.3496 14.3411 14.3586 15.3122C14.5099 15.9331 15.3551 15.9321 15.4935 15.2906C15.5028 14.2657 15.5017 13.2407 15.4902 12.2158C15.322 11.5057 14.3029 11.653 14.3496 12.3984Z" fill="white" stroke="white" stroke-width="0.5"/> </svg>',
  christmas:   '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><rect width="24" height="24" rx="12" fill="#333"></rect><path d="M12 5.8l2.1 3.5h-1.4l2.1 3.3h-1.4l2.1 3.4H8.5l2.1-3.4H9.2l2.1-3.3H9.9L12 5.8z" fill="white"></path><rect x="11.25" y="15.9" width="1.5" height="2.1" fill="white"></rect><circle cx="12" cy="6.4" r="0.9" fill="white"></circle></svg>',
  baby:     '<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"> <rect width="48" height="48" rx="24" fill="#333333"/> <path d="M23.914 10H24.0857C24.7267 10.0334 25.2495 10.2494 25.7171 10.6885C26.1879 11.1463 26.4537 11.7456 26.4712 12.403C26.4778 12.7803 26.4729 13.1648 26.4734 13.5427C27.361 13.7641 28.085 14.2711 28.5947 15.0307C29.0016 15.6514 29.1859 16.3175 29.181 17.0591C29.1865 17.1783 29.1695 17.2948 29.1903 17.4129C29.8044 17.6174 30.3157 18.0773 30.599 18.6576C31.0688 19.6015 30.8566 20.8019 30.0768 21.5128C30.1145 21.591 30.1725 21.6424 30.2222 21.7124C30.6586 22.3025 30.838 22.9423 30.8216 23.6741V34.611C30.8211 34.768 30.8243 34.9244 30.8172 35.0819C30.7921 36.058 30.2775 36.9686 29.4637 37.504C28.9732 37.8228 28.493 37.9639 27.9111 38H20.0361C19.5188 37.9634 19.0742 37.842 18.6263 37.5767C18.2998 37.3815 18.0171 37.1338 17.7836 36.8335C17.3225 36.2303 17.135 35.5872 17.1492 34.8303V23.6697C17.141 23.1578 17.2143 22.7094 17.4308 22.2434C17.5615 21.9558 17.7234 21.7359 17.9203 21.4937C17.5719 21.1426 17.3461 20.7472 17.2361 20.2627C16.9747 19.0475 17.6321 17.8602 18.7904 17.4249V17.1066C18.7822 16.4952 18.891 15.9402 19.1661 15.3927C19.6238 14.4674 20.5354 13.7466 21.5472 13.5345C21.5586 13.1998 21.5488 12.858 21.5521 12.5222C21.5472 11.902 21.738 11.3475 22.1372 10.8723C22.613 10.3265 23.1927 10.052 23.914 10ZM27.5436 17.2702C27.5415 16.8912 27.5442 16.5942 27.3889 16.236C27.099 15.5661 26.4712 15.1231 25.739 15.0903C25.3813 15.0892 25.1084 14.9645 24.929 14.6452C24.7786 14.3772 24.8497 14.0168 24.8333 13.7215C24.8322 13.3042 24.835 12.8744 24.8328 12.4587C24.771 11.3677 23.2419 11.3781 23.1927 12.468L23.1932 14.2153C23.1932 14.7179 22.8613 15.0701 22.3565 15.0859C21.8097 15.0914 21.3886 15.2555 20.9921 15.6334C20.5289 16.1009 20.3976 16.6287 20.4321 17.2734H27.2806C27.3686 17.2729 27.4556 17.2756 27.5436 17.2702ZM28.959 20.3195C29.4675 19.8115 29.1443 18.9616 28.4263 18.9162C28.3027 18.9097 28.1753 18.9152 28.0511 18.9141H20.7728C20.3938 18.9152 20.0028 18.9119 19.6254 18.9152C18.9599 18.937 18.5869 19.6731 18.9768 20.2151C19.2355 20.5569 19.5516 20.5695 19.9475 20.5547C22.7213 20.5552 25.4956 20.5536 28.2699 20.5558C28.54 20.564 28.7599 20.5098 28.959 20.3195ZM18.7915 33.3516C18.7882 33.8629 18.792 34.377 18.7898 34.8877C18.769 35.3832 18.9714 35.8267 19.3782 36.1138C19.661 36.3047 19.9377 36.3692 20.2768 36.3599L27.227 36.3594C27.7329 36.3528 28.178 36.4239 28.6111 36.1002C29.0377 35.7802 29.2034 35.3553 29.1815 34.8298V23.6702C29.2034 23.1425 29.0393 22.7214 28.6117 22.3993C28.3104 22.1784 28.1381 22.1838 27.7788 22.1953C25.1686 22.1942 22.5589 22.1975 19.9492 22.1937C19.7425 22.1838 19.6178 22.2385 19.4439 22.3424C18.9971 22.6224 18.7668 23.0867 18.7898 23.6123C18.792 24.123 18.7882 24.6371 18.7915 25.1484C19.4893 25.1479 20.1887 25.1495 20.8854 25.1473C22.0607 25.149 22.0607 26.7874 20.8854 26.7896C20.1887 26.788 19.4887 26.7896 18.7915 26.7891C18.7893 27.3348 18.7893 27.8839 18.7915 28.4297H21.265H22.5786C23.1479 28.4259 23.5569 28.987 23.36 29.5273C23.2091 29.9161 22.8804 30.09 22.473 30.0714C21.2458 30.0692 20.0186 30.0709 18.7915 30.0703C18.7893 30.6161 18.7893 31.1652 18.7915 31.7109C19.4893 31.7104 20.1887 31.712 20.8854 31.7098C22.0607 31.7115 22.0607 33.3499 20.8854 33.3521C20.1887 33.3505 19.4887 33.3521 18.7915 33.3516Z" fill="white"/> </svg>',
  unisex:     '<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"> <rect width="48" height="48" rx="24" fill="#333333"/> <path d="M23.914 10H24.0857C24.7267 10.0334 25.2495 10.2494 25.7171 10.6885C26.1879 11.1463 26.4537 11.7456 26.4712 12.403C26.4778 12.7803 26.4729 13.1648 26.4734 13.5427C27.361 13.7641 28.085 14.2711 28.5947 15.0307C29.0016 15.6514 29.1859 16.3175 29.181 17.0591C29.1865 17.1783 29.1695 17.2948 29.1903 17.4129C29.8044 17.6174 30.3157 18.0773 30.599 18.6576C31.0688 19.6015 30.8566 20.8019 30.0768 21.5128C30.1145 21.591 30.1725 21.6424 30.2222 21.7124C30.6586 22.3025 30.838 22.9423 30.8216 23.6741V34.611C30.8211 34.768 30.8243 34.9244 30.8172 35.0819C30.7921 36.058 30.2775 36.9686 29.4637 37.504C28.9732 37.8228 28.493 37.9639 27.9111 38H20.0361C19.5188 37.9634 19.0742 37.842 18.6263 37.5767C18.2998 37.3815 18.0171 37.1338 17.7836 36.8335C17.3225 36.2303 17.135 35.5872 17.1492 34.8303V23.6697C17.141 23.1578 17.2143 22.7094 17.4308 22.2434C17.5615 21.9558 17.7234 21.7359 17.9203 21.4937C17.5719 21.1426 17.3461 20.7472 17.2361 20.2627C16.9747 19.0475 17.6321 17.8602 18.7904 17.4249V17.1066C18.7822 16.4952 18.891 15.9402 19.1661 15.3927C19.6238 14.4674 20.5354 13.7466 21.5472 13.5345C21.5586 13.1998 21.5488 12.858 21.5521 12.5222C21.5472 11.902 21.738 11.3475 22.1372 10.8723C22.613 10.3265 23.1927 10.052 23.914 10ZM27.5436 17.2702C27.5415 16.8912 27.5442 16.5942 27.3889 16.236C27.099 15.5661 26.4712 15.1231 25.739 15.0903C25.3813 15.0892 25.1084 14.9645 24.929 14.6452C24.7786 14.3772 24.8497 14.0168 24.8333 13.7215C24.8322 13.3042 24.835 12.8744 24.8328 12.4587C24.771 11.3677 23.2419 11.3781 23.1927 12.468L23.1932 14.2153C23.1932 14.7179 22.8613 15.0701 22.3565 15.0859C21.8097 15.0914 21.3886 15.2555 20.9921 15.6334C20.5289 16.1009 20.3976 16.6287 20.4321 17.2734H27.2806C27.3686 17.2729 27.4556 17.2756 27.5436 17.2702ZM28.959 20.3195C29.4675 19.8115 29.1443 18.9616 28.4263 18.9162C28.3027 18.9097 28.1753 18.9152 28.0511 18.9141H20.7728C20.3938 18.9152 20.0028 18.9119 19.6254 18.9152C18.9599 18.937 18.5869 19.6731 18.9768 20.2151C19.2355 20.5569 19.5516 20.5695 19.9475 20.5547C22.7213 20.5552 25.4956 20.5536 28.2699 20.5558C28.54 20.564 28.7599 20.5098 28.959 20.3195ZM18.7915 33.3516C18.7882 33.8629 18.792 34.377 18.7898 34.8877C18.769 35.3832 18.9714 35.8267 19.3782 36.1138C19.661 36.3047 19.9377 36.3692 20.2768 36.3599L27.227 36.3594C27.7329 36.3528 28.178 36.4239 28.6111 36.1002C29.0377 35.7802 29.2034 35.3553 29.1815 34.8298V23.6702C29.2034 23.1425 29.0393 22.7214 28.6117 22.3993C28.3104 22.1784 28.1381 22.1838 27.7788 22.1953C25.1686 22.1942 22.5589 22.1975 19.9492 22.1937C19.7425 22.1838 19.6178 22.2385 19.4439 22.3424C18.9971 22.6224 18.7668 23.0867 18.7898 23.6123C18.792 24.123 18.7882 24.6371 18.7915 25.1484C19.4893 25.1479 20.1887 25.1495 20.8854 25.1473C22.0607 25.149 22.0607 26.7874 20.8854 26.7896C20.1887 26.788 19.4887 26.7896 18.7915 26.7891C18.7893 27.3348 18.7893 27.8839 18.7915 28.4297H21.265H22.5786C23.1479 28.4259 23.5569 28.987 23.36 29.5273C23.2091 29.9161 22.8804 30.09 22.473 30.0714C21.2458 30.0692 20.0186 30.0709 18.7915 30.0703C18.7893 30.6161 18.7893 31.1652 18.7915 31.7109C19.4893 31.7104 20.1887 31.712 20.8854 31.7098C22.0607 31.7115 22.0607 33.3499 20.8854 33.3521C20.1887 33.3505 19.4887 33.3521 18.7915 33.3516Z" fill="white"/> </svg>',
  winter:        '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><rect width="24" height="24" rx="12" fill="#333"/><rect x="7" y="11" width="10" height="7" rx="1.5" fill="white" opacity="0.92"/><rect x="11.2" y="11" width="1.6" height="7" fill="#333" opacity="0.18"/><rect x="6.5" y="9" width="11" height="3" rx="1.2" fill="white"/><path d="M10.5 9C9.3 9 8.7 8.2 8.7 7.5C8.7 6.8 9.2 6.3 9.9 6.3C10.7 6.3 11.3 7 12 8C12.7 7 13.3 6.3 14.1 6.3C14.8 6.3 15.3 6.8 15.3 7.5C15.3 8.2 14.7 9 13.5 9H10.5Z" fill="white" opacity="0.95"/></svg>',
  birthday:    '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><rect width="24" height="24" rx="12" fill="#333"/><rect x="7" y="12" width="10" height="6" rx="1" stroke="white" stroke-width="1.3"/><path d="M9 12V11M12 12V10M15 12V11" stroke="white" stroke-width="1.3" stroke-linecap="round"/></svg>',
  anniversary: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><rect width="24" height="24" rx="12" fill="#333"/><path d="M12 17s-5-3.5-5-7a3 3 0 015-2.2A3 3 0 0117 10c0 3.5-5 7-5 7z" stroke="white" stroke-width="1.3" stroke-linejoin="round"/></svg>',
  thankyou:    '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><rect width="24" height="24" rx="12" fill="#333"/><path d="M8 12l3 3 5-5" stroke="white" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>',
  wedding:     '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><rect width="24" height="24" rx="12" fill="#333"/><circle cx="9.5" cy="13" r="2.5" stroke="white" stroke-width="1.3"/><circle cx="14.5" cy="13" r="2.5" stroke="white" stroke-width="1.3"/><path d="M12 8v3" stroke="white" stroke-width="1.3" stroke-linecap="round"/></svg>',
  newbaby:     '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><rect width="24" height="24" rx="12" fill="#333"/><circle cx="12" cy="10" r="2.5" stroke="white" stroke-width="1.3"/><path d="M8.5 17.5c0-2 1.567-3.5 3.5-3.5s3.5 1.567 3.5 3.5" stroke="white" stroke-width="1.3" stroke-linecap="round"/></svg>',
  getwell:     '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><rect width="24" height="24" rx="12" fill="#333"/><rect x="7" y="7" width="10" height="10" rx="2" stroke="white" stroke-width="1.3"/><path d="M12 9.5v5M9.5 12h5" stroke="white" stroke-width="1.4" stroke-linecap="round"/></svg>',
  congrats:    '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><rect width="24" height="24" rx="12" fill="#333"/><path d="M7 17l4-9 2 5 2-3 2 4" stroke="white" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg>',
  anyone:      '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><rect width="24" height="24" rx="12" fill="#333"/><circle cx="9.5" cy="9" r="2" stroke="white" stroke-width="1.3"/><circle cx="14.5" cy="9" r="2" stroke="white" stroke-width="1.3"/><path d="M6 17c0-2 1.567-3.5 3.5-3.5S13 15 13 17" stroke="white" stroke-width="1.3" stroke-linecap="round"/><path d="M13 15c.4-.33.9-.5 1.5-.5C16.433 14.5 18 16.067 18 18" stroke="white" stroke-width="1.3" stroke-linecap="round"/></svg>',
  forhim:      '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><rect width="24" height="24" rx="12" fill="#333"/><circle cx="12" cy="10" r="3" stroke="white" stroke-width="1.4"/><path d="M7 19c0-2.761 2.239-5 5-5s5 2.239 5 5" stroke="white" stroke-width="1.4" stroke-linecap="round"/></svg>',
  forher:      '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><rect width="24" height="24" rx="12" fill="#333"/><circle cx="12" cy="9.5" r="3" stroke="white" stroke-width="1.4"/><path d="M12 12.5v4M10 15h4" stroke="white" stroke-width="1.4" stroke-linecap="round"/></svg>',
   toshare:      '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><rect width="24" height="24" rx="12" fill="#333"/><circle cx="12" cy="9.5" r="3" stroke="white" stroke-width="1.4"/><path d="M12 12.5v4M10 15h4" stroke="white" stroke-width="1.4" stroke-linecap="round"/></svg>',
  forkids:     '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><rect width="24" height="24" rx="12" fill="#333"/><circle cx="12" cy="9" r="2.5" stroke="white" stroke-width="1.3"/><path d="M8 18c0-2.2 1.8-4 4-4s4 1.8 4 4" stroke="white" stroke-width="1.3" stroke-linecap="round"/><path d="M9 7c.5-1.5 1.5-2 3-2" stroke="white" stroke-width="1.1" stroke-linecap="round"/></svg>',
  anyprice:    '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><rect width="24" height="24" rx="12" fill="#333"/><text x="12" y="16" text-anchor="middle" fill="white" font-size="9" font-family="sans-serif" font-weight="bold">Any</text></svg>',
  under99:     '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><rect width="24" height="24" rx="12" fill="#333"/><text x="12" y="15" text-anchor="middle" fill="white" font-size="7.5" font-family="sans-serif" font-weight="bold">&lt;$99</text></svg>',
  b100149:     '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><rect width="24" height="24" rx="12" fill="#333"/><text x="12" y="15" text-anchor="middle" fill="white" font-size="6.2" font-family="sans-serif" font-weight="bold">$100-149</text></svg>',
  b150199:     '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><rect width="24" height="24" rx="12" fill="#333"/><text x="12" y="15" text-anchor="middle" fill="white" font-size="6.2" font-family="sans-serif" font-weight="bold">$150-199</text></svg>',
  over200:     '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><rect width="24" height="24" rx="12" fill="#333"/><text x="12" y="15" text-anchor="middle" fill="white" font-size="8" font-family="sans-serif" font-weight="bold">$200+</text></svg>',
  babygirl:    '<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"> <rect width="48" height="48" rx="24" fill="#333333"/> <g clip-path="url(#clip0_11951_26191)"> <path d="M18.697 10H18.7938C18.9157 10.0219 19.0114 10.0613 19.1213 10.117C19.497 10.3084 19.8749 10.4971 20.2512 10.6874C20.973 11.0527 21.6982 11.4148 22.4179 11.7817C22.5973 11.6778 22.728 11.5269 22.9276 11.4421C23.6598 11.0478 24.5491 11.0948 25.2469 11.5405C25.3655 11.6127 25.4574 11.7194 25.5821 11.7817C26.3018 11.4148 27.0275 11.0522 27.7488 10.6874C28.1251 10.4971 28.503 10.3084 28.8787 10.1165C28.9897 10.0607 29.0859 10.0219 29.2084 10H29.2998C29.699 10.0842 29.8434 10.315 29.8335 10.7131C29.8319 12.4259 29.8335 14.1388 29.833 15.8516C29.8335 15.9248 29.8319 15.9976 29.8346 16.0703C30.3372 16.3372 30.8124 16.6134 31.2756 16.9442C31.4851 17.0815 31.6727 17.2395 31.8728 17.3883C32.5105 17.9056 33.0869 18.4585 33.608 19.094C34.5055 20.1697 35.1984 21.4177 35.6462 22.7449C35.7879 23.1688 35.8967 23.5915 35.9979 24.0263C36.5645 24.1247 36.9976 24.3533 37.393 24.7716C37.7238 25.1446 37.9459 25.6204 37.9814 26.1202L38 26.269V26.3838C37.977 26.5145 37.9798 26.6507 37.9524 26.7803C37.8223 27.4262 37.428 27.9916 36.862 28.3296C36.5754 28.5052 36.3129 28.5735 35.9919 28.6473C35.8732 29.0947 35.7852 29.5519 35.6162 29.9845C35.4953 30.3202 35.3914 30.644 35.2295 30.9639C35.0857 31.2784 34.9561 31.5786 34.7718 31.8734C34.5984 32.178 34.4377 32.4673 34.226 32.7484C34.0308 33.0344 33.8454 33.3023 33.6141 33.561C33.4057 33.8148 33.2116 34.0543 32.9709 34.2796C32.7221 34.535 32.4875 34.7762 32.2075 34.9982C31.9395 35.235 31.6798 35.4477 31.3828 35.6473C31.0924 35.8655 30.8053 36.052 30.4898 36.232C30.1775 36.4327 29.8647 36.588 29.53 36.7471C29.1111 36.9691 28.6539 37.1206 28.2142 37.2962C27.8998 37.3963 27.5645 37.4914 27.2479 37.5871C26.9542 37.6609 26.6491 37.7151 26.3527 37.7818C26.0278 37.854 25.6855 37.8753 25.3552 37.9229C24.9477 37.9836 24.5403 37.9639 24.1318 38H23.8682C23.4493 37.9634 23.0331 37.9836 22.6148 37.9191C22.2943 37.8731 21.9629 37.8523 21.6473 37.7818C21.3509 37.7151 21.0452 37.6609 20.7516 37.5871C20.4344 37.4909 20.098 37.3962 19.783 37.2956C19.3445 37.1201 18.8884 36.9686 18.47 36.7471C18.1353 36.588 17.8225 36.4327 17.5102 36.232C17.1947 36.052 16.9081 35.8661 16.6177 35.6479C16.3213 35.4483 16.061 35.2355 15.793 34.9993C15.512 34.7767 15.2773 34.5361 15.0285 34.2802C14.8087 34.0718 14.6266 33.8563 14.4363 33.6217C14.2082 33.3603 14.0108 33.1027 13.8194 32.814C13.6105 32.5302 13.4371 32.2512 13.2681 31.9428C13.086 31.6464 12.9444 31.3566 12.8049 31.0388C12.6452 30.7178 12.5282 30.4034 12.4123 30.0643C12.2291 29.6033 12.1328 29.1264 12.0081 28.6473C11.8845 28.6107 11.7544 28.5899 11.6319 28.5549C11.0117 28.3509 10.508 27.9184 10.2302 27.3261C10.0727 27.0089 10.0317 26.73 10 26.3838V26.269L10.0186 26.1202C10.0541 25.6204 10.2767 25.1446 10.607 24.7711C11.0041 24.3516 11.4334 24.1252 12.0021 24.0263C12.0841 23.708 12.1454 23.3913 12.2504 23.0791C12.5648 22.0291 13.022 21.0485 13.6247 20.133C13.8057 19.8416 14.0157 19.578 14.2164 19.3007C14.2859 19.2247 14.3504 19.1443 14.4166 19.0645C15.2128 18.1041 16.1934 17.2548 17.251 16.5942C17.548 16.4001 17.8542 16.2387 18.1654 16.0703C18.1681 15.997 18.1665 15.9248 18.167 15.8516C18.1665 14.1388 18.1681 12.4259 18.1665 10.7131C18.1561 10.3177 18.3005 10.0842 18.697 10ZM19.333 11.5395V15.25C19.3335 15.3238 19.3313 15.3971 19.3346 15.4704C20.0904 15.0865 20.8489 14.7059 21.6047 14.323C21.6637 14.2957 21.7119 14.2634 21.7753 14.247C21.7884 14.0884 21.6922 13.932 21.6905 13.7658C21.667 13.5831 21.6665 13.4169 21.6905 13.2342C21.6922 13.0685 21.7895 12.911 21.7753 12.753C21.7119 12.736 21.6637 12.7043 21.6047 12.677L19.5249 11.628C19.4593 11.5969 19.4041 11.5591 19.333 11.5395ZM28.667 11.5395C28.5959 11.5591 28.5407 11.5969 28.4751 11.628L26.3942 12.6764C26.3362 12.7037 26.2876 12.7349 26.2252 12.7519C26.2034 12.8979 26.2974 13.033 26.3029 13.1828C26.3352 13.3983 26.3346 13.6017 26.3029 13.8172C26.298 13.9676 26.2034 14.1021 26.2252 14.2481C26.2876 14.2651 26.3362 14.2962 26.3942 14.3236L28.4751 15.372C28.5407 15.4031 28.5959 15.4409 28.667 15.4605V11.5395ZM24 12.3368C23.4909 12.3346 23.0359 12.6759 22.8877 13.1604C22.5694 14.2476 23.8031 15.1029 24.7082 14.4215C25.5865 13.7319 25.1063 12.3499 24 12.3368ZM23.5051 15.8543C23.1715 16.1075 22.8948 16.3498 22.6733 16.7123C22.5601 16.8797 22.4868 17.029 22.4157 17.2182C22.1237 17.9111 22.2347 18.6877 22.7263 19.258C23.2393 19.8257 24.0788 20.1013 24.7984 19.7661C25.4727 19.4806 26.0415 18.6002 25.6166 17.9002C25.4372 17.6196 25.2474 17.5277 24.9472 17.42C24.2073 17.117 24.6016 16.0807 25.3628 16.3388C25.9195 16.5084 26.3554 16.8573 26.6502 17.3582C27.2337 18.3984 26.8438 19.6485 25.9688 20.3841C25.2649 20.9911 24.3019 21.2235 23.3995 20.9862C21.8163 20.5651 20.8396 19.0327 21.1398 17.4156C21.2361 16.9169 21.4455 16.4963 21.7064 16.0676C21.2935 16.1622 20.8855 16.2448 20.4841 16.3837C19.6977 16.6276 18.9512 16.9502 18.2398 17.3648C17.7536 17.6393 17.3041 17.9428 16.8704 18.2939C16.44 18.6319 16.0473 18.9945 15.6793 19.3991C15.4195 19.6578 15.2145 19.9487 14.9777 20.2255C14.8158 20.4634 14.6457 20.7034 14.4888 20.9435C14.0026 21.737 13.611 22.5754 13.3545 23.4706C13.2851 23.702 13.2173 23.9218 13.1757 24.1602C13.0559 24.7 13.0718 25.2004 12.3609 25.173C11.511 25.1479 10.9445 26.0021 11.2595 26.7825C11.4465 27.2107 11.8337 27.4759 12.3013 27.4956C13.063 27.5388 13.051 27.9009 13.185 28.5303C13.2419 28.8595 13.3409 29.1548 13.4426 29.4715C13.5306 29.793 13.6597 30.0785 13.7893 30.3842C14.0841 31.0919 14.4849 31.7421 14.923 32.3688C15.1237 32.604 15.3047 32.8616 15.5098 33.0918C15.8078 33.4008 16.0823 33.7185 16.4154 33.9914C16.668 34.2266 16.9191 34.4289 17.2002 34.6285C17.5605 34.9151 17.9691 35.1437 18.3606 35.3843C18.7998 35.6096 19.234 35.8431 19.6999 36.011C20.2681 36.2434 20.8538 36.4201 21.4543 36.5475C21.952 36.6744 22.4573 36.7236 22.9653 36.7865C23.6177 36.833 24.2767 36.8373 24.9297 36.7941C25.2644 36.7668 25.622 36.7099 25.9573 36.67C26.2657 36.6148 26.5878 36.5355 26.8957 36.4715C27.2025 36.3927 27.5213 36.2834 27.8265 36.1948C28.124 36.0903 28.433 35.9541 28.7283 35.8393C29.0072 35.7141 29.2921 35.5577 29.5683 35.422C29.8417 35.2722 30.1184 35.0873 30.387 34.9266C30.6418 34.7548 30.8994 34.5498 31.1493 34.3682C31.3855 34.179 31.6185 33.9559 31.8487 33.7579C32.0659 33.549 32.2802 33.3078 32.4913 33.0907C32.6915 32.8627 32.884 32.6007 33.0765 32.3645C33.2575 32.1173 33.4298 31.834 33.602 31.5786C33.7557 31.3194 33.899 31.0273 34.0445 30.7621C34.1741 30.493 34.2867 30.1945 34.4065 29.9199C34.518 29.6306 34.6028 29.3113 34.7018 29.0159C34.8063 28.6539 34.8544 28.2629 34.9577 27.9052C35.078 27.57 35.3006 27.4694 35.6424 27.4934C36.1275 27.5098 36.5508 27.2238 36.74 26.783C37.0539 26.0065 36.4955 25.1621 35.6517 25.1736C35.3214 25.1987 35.0595 25.0872 34.9534 24.752C34.8473 24.3719 34.8008 23.9738 34.6837 23.597C34.5935 23.3263 34.5164 23.038 34.4169 22.7717C34.2922 22.4862 34.1746 22.1713 34.039 21.8929C33.8924 21.6277 33.7508 21.3367 33.5955 21.078C33.4216 20.8227 33.2515 20.5383 33.0677 20.2911C32.8741 20.0554 32.6849 19.7934 32.4826 19.567C32.2682 19.3483 32.0549 19.1044 31.8334 18.8955C31.6027 18.698 31.3724 18.4738 31.1356 18.2868C30.8857 18.1069 30.6314 17.9034 30.376 17.7339C30.1184 17.5791 29.8538 17.4047 29.5923 17.2576C29.3058 17.117 29.0055 16.9524 28.7152 16.8228C28.4313 16.7118 28.1382 16.5849 27.8533 16.4816C27.552 16.3902 27.2315 16.2847 26.9291 16.2016C26.1651 16.0222 25.3902 15.8866 24.6043 15.8592C24.2302 15.8373 23.8797 15.8275 23.5051 15.8543Z" fill="white"/> <path d="M28.64 31.7375C28.5082 32.1942 27.5993 32.6519 27.175 32.8078C26.8162 32.9647 26.4154 33.0506 26.0375 33.1446C25.4649 33.2365 24.889 33.3278 24.3077 33.3278C23.3714 33.3524 22.4374 33.2753 21.5301 33.0353C20.8449 32.8646 20.1164 32.5551 19.5871 32.0788C19.2775 31.8141 19.2447 31.3706 19.5821 31.1163C19.8753 30.9276 20.1449 30.9987 20.385 31.2246C20.7656 31.5565 21.2693 31.7452 21.7456 31.889C22.1973 32.0137 22.6682 32.0837 23.1336 32.1307C23.8664 32.1756 24.6107 32.1832 25.3386 32.0722C25.9877 31.9896 26.6527 31.8113 27.2291 31.4963C27.4243 31.3924 27.5709 31.2574 27.7426 31.1267C28.19 30.8078 28.7713 31.2191 28.64 31.7375Z" fill="white"/> <path d="M21.2724 27.4684C20.9498 27.5646 20.6922 27.4241 20.538 27.1403C20.1316 26.4867 19.4409 26.0782 18.7087 26.531C18.4166 26.7131 18.2465 26.9718 18.0551 27.2474C17.6133 27.8359 16.7055 27.2742 17.1085 26.5786C17.5712 25.79 18.3565 25.1917 19.2971 25.1721C20.2629 25.16 21.075 25.7627 21.5535 26.5671C21.7662 26.9056 21.6498 27.3229 21.2724 27.4684Z" fill="white"/> <path d="M27.5505 27.0051C27.3755 27.295 27.1994 27.5427 26.815 27.4836C26.3819 27.3967 26.214 26.934 26.4469 26.5671C26.9446 25.7287 27.8054 25.1129 28.8133 25.1764C29.0703 25.1873 29.265 25.2486 29.5023 25.3388C30.0662 25.5373 30.6316 26.0957 30.9122 26.6152C31.126 27.004 30.8848 27.4656 30.4468 27.4984C30.0913 27.5061 29.9497 27.2878 29.7911 27.0144C29.5488 26.7153 29.3323 26.4856 28.9445 26.3757C28.448 26.2499 27.9864 26.4763 27.6747 26.858C27.6342 26.9078 27.5937 26.957 27.5505 27.0051Z" fill="white"/> </g> <defs> <clipPath id="clip0_11951_26191"> <rect width="28" height="28" fill="white" transform="translate(10 10)"/> </clipPath> </defs> </svg>',
  babyboy: '<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"> <rect width="48" height="48" rx="24" fill="#333333"/> <path d="M26.0094 10H26.2189C26.8204 10.3396 27.183 11.1298 27.1808 11.8058C27.229 11.8304 27.2787 11.8463 27.329 11.8665C28.3222 12.2356 29.2426 12.7869 30.0415 13.4825C30.2297 13.6334 30.2854 13.8604 30.1471 14.0671C29.9699 14.2963 29.6904 14.2848 29.4892 14.0939C29.2114 13.8456 28.9232 13.6307 28.6115 13.4262C28.1275 13.1117 27.5702 12.8246 27.0272 12.631C26.541 13.9227 24.9786 14.4762 23.782 13.7723C23.5758 13.6367 23.1766 13.3966 23.187 13.1145C23.1947 12.748 23.6119 12.5665 23.8903 12.8263C24.1025 13.028 24.2813 13.1407 24.5701 13.2167C25.2444 13.3945 25.993 13.0226 26.2435 12.3723C26.1626 12.3592 26.0854 12.3362 26.0061 12.3182C23.6776 11.7713 21.1264 12.199 19.1615 13.5831C18.5681 13.9998 18.0639 14.4734 17.6067 15.0356L17.5361 15.128C16.6081 16.3312 16.1104 17.7738 16.158 19.2985C16.2111 20.8385 16.8143 22.2615 17.8238 23.4159C18.1744 23.2327 18.4877 23.1113 18.8826 23.0468C19.3758 22.9653 19.8029 23.0145 20.2847 23.1206C21.577 23.3815 22.8119 23.8119 24.0002 24.3779C24.8429 23.9792 25.7185 23.6391 26.6165 23.3886C27.1119 23.2464 27.6172 23.1299 28.1253 23.0441C28.8707 22.9358 29.5182 23.0648 30.1766 23.4165C30.9597 22.512 31.4902 21.4833 31.7254 20.3064C32.0584 18.6105 31.6811 16.8917 30.7115 15.4693C30.5501 15.2609 30.5321 15.0083 30.7503 14.8311C30.974 14.672 31.2376 14.7502 31.3732 14.9798C31.698 15.4666 31.9698 15.962 32.176 16.5116C32.2422 16.5171 32.3072 16.51 32.3734 16.5105C34.3629 16.4876 35.8094 18.3705 35.2697 20.2911C34.9087 21.5566 33.7433 22.4447 32.4237 22.4447C32.229 22.4573 32.0333 22.4004 31.8457 22.408C31.6094 22.8805 31.301 23.341 30.9658 23.749C30.9182 23.808 30.8706 23.8562 30.8351 23.9234C31.1933 24.2554 31.4689 24.718 31.6236 25.1802C32.194 26.8547 32.3023 28.7009 31.9693 30.4362C31.89 30.8879 31.7647 31.3112 31.6395 31.7503C30.8777 34.6471 28.7274 37.1463 25.7376 37.8245C25.2553 37.9366 24.7932 37.9803 24.3004 38H23.869C23.496 37.9666 23.1378 37.9382 22.7697 37.8595C21.8182 37.6713 20.8759 37.2639 20.0671 36.7312C19.8019 36.5792 19.7466 36.256 19.9741 36.0438C20.189 35.8716 20.3947 35.9476 20.5943 36.092C21.6344 36.7684 22.8644 37.1688 24.1085 37.178C26.8981 37.2032 29.1939 35.427 30.3347 32.9595C30.5447 32.511 30.6989 32.0642 30.8378 31.5901C30.8083 31.5327 30.7738 31.4785 30.7399 31.4233C30.0634 30.3312 29.2431 29.3222 28.3298 28.4198C26.0362 26.1613 23.0448 24.4572 19.8631 23.8737C19.1276 23.7408 18.5276 23.8983 17.931 24.3314C17.534 24.6661 17.2928 25.0035 17.1347 25.5017C16.7722 26.5993 16.6251 27.7144 16.6737 28.8694C16.7344 30.3536 17.1293 31.8045 17.8462 33.106C18.0972 33.5648 18.38 33.9761 18.7015 34.3868C18.87 34.5875 19.0406 34.7827 19.2227 34.9692C19.6258 35.4056 19.0592 35.9279 18.6676 35.5752C18.456 35.3646 18.2372 35.1103 18.0453 34.8784C17.6986 34.4377 17.3961 33.9909 17.1265 33.4987C15.744 30.9945 15.4509 27.8899 16.3757 25.1802C16.5294 24.718 16.8061 24.2548 17.1643 23.9234C17.0702 23.7769 16.9455 23.6484 16.84 23.5095C16.5835 23.1529 16.3478 22.8045 16.1531 22.4086C15.9666 22.3998 15.7703 22.4578 15.5751 22.4447C14.1395 22.442 12.9014 21.3974 12.6586 19.9832C12.3458 18.1468 13.7665 16.4892 15.6259 16.5105C15.6921 16.51 15.7577 16.5171 15.8239 16.5122C16.0919 15.7952 16.484 15.1466 16.951 14.5434C17.2906 14.1273 17.6411 13.7559 18.0519 13.4081C19.8243 11.896 22.1408 11.1676 24.4596 11.2786C25.1011 11.3081 25.7092 11.3995 26.3321 11.552C26.3042 11.3459 26.2069 11.1435 26.0876 10.974C25.9936 10.823 25.7956 10.7115 25.7376 10.5491C25.6534 10.2893 25.7879 10.117 26.0094 10ZM15.5532 17.3276L15.4744 17.333C14.5579 17.3795 13.7797 17.9986 13.5199 18.8763C13.1015 20.3381 14.2746 21.754 15.7872 21.614L15.749 21.4838C15.3016 20.238 15.2147 18.8709 15.5001 17.5786C15.5182 17.4944 15.5411 17.4129 15.5532 17.3276ZM32.4379 17.3336C32.5965 17.9171 32.6698 18.5848 32.6638 19.1891C32.654 19.9384 32.5222 20.692 32.2794 21.4012C32.2564 21.474 32.2241 21.538 32.2126 21.6145C33.7258 21.7529 34.8967 20.3387 34.4789 18.8769C34.2142 17.9745 33.3829 17.333 32.4379 17.3336ZM31.1298 30.4996L31.1522 30.3421C31.4142 29.0176 31.3972 27.5826 31.0817 26.2684C31.0155 25.9808 30.9302 25.7002 30.8378 25.4197C30.4555 24.3155 29.3328 23.6582 28.1794 23.8655C27.1469 24.0514 26.1144 24.362 25.1459 24.7667C25.077 24.7962 25.0119 24.823 24.9386 24.8416C25.0119 24.9177 25.0945 24.9499 25.1826 25.0035C26.0023 25.4722 26.786 26.0125 27.521 26.6048C28.8603 27.6816 30.0339 28.929 31.0106 30.3443C31.0489 30.4001 31.0811 30.4509 31.1298 30.4996Z" fill="white"/> <path d="M20.402 18.5695C19.9164 18.6624 20.2658 19.2296 19.7671 19.3411C19.4417 19.398 19.2257 19.1349 19.2771 18.8194C19.3936 17.7946 20.6339 17.374 21.3465 18.1232C21.6215 18.3934 21.8884 19.1557 21.3908 19.3285C21.1151 19.41 20.874 19.2394 20.8515 18.9534C20.8329 18.7002 20.6634 18.535 20.402 18.5695Z" fill="white"/> <path d="M27.1324 19.0415C27.0143 19.5118 26.2902 19.4369 26.3318 18.8692C26.3509 18.5411 26.5112 18.2267 26.7649 18.0183C27.5273 17.3943 28.6604 17.892 28.7266 18.8703C28.7741 19.438 28.008 19.531 27.9166 18.995C27.8991 18.7429 27.7816 18.5641 27.5043 18.5646C27.2123 18.6018 27.1625 18.7954 27.1324 19.0415Z" fill="white"/> <path d="M23.2603 19.466C23.4588 19.5158 23.5583 19.7394 23.7809 19.7969C24.0702 19.886 24.3174 19.8067 24.5252 19.5956C24.9512 19.1816 25.5101 19.7608 25.106 20.1753C24.5011 20.8222 23.4533 20.8086 22.8654 20.1452C22.5843 19.8346 22.8671 19.3736 23.2603 19.466Z" fill="white"/> </svg>'
};


function yieldToMain() {
  /* Use scheduler.yield() when available (Chrome 115+),
     otherwise fall back to a 0ms setTimeout. */
  if (typeof scheduler !== 'undefined' && scheduler.yield) {
    return scheduler.yield();
  }
  return new Promise(function(resolve) { setTimeout(resolve, 0); });
}
/* Process large arrays in small batches, yielding to the main thread
   between each batch so clicks/taps don't get stuck behind this work. */
function normalizeInChunks(raw, chunkSize) {
  chunkSize = chunkSize || 50;
  var out = [];
  var i = 0;

  function step() {
    var end = Math.min(i + chunkSize, raw.length);
    for (; i < end; i++) {
      var p = normalizeProduct(raw[i]);
      if (p && p.title) out.push(p);
    }
    if (i < raw.length) return yieldToMain().then(step);
    return out;
  }

  return step();
}


var S = { occasion:null, recipient:null, budget:null };

var allProducts    = [];
var allCollections = [];
var occPool        = [];
var recPool        = [];
var finalPool      = [];


function init() {
  buildOccasionDropdown();
  bindTrigger('occasion');
  bindTrigger('recipient');
  bindTrigger('budget');
  bindFind();
  bindRestart();

  document.addEventListener('click', closeAll, { passive: true });
  /* Prefetch collections in the background don't block init. */
  setTimeout(fetchAllCollections, 0);
}

function fetchAllCollections() {
  var all = [];
  function fetchPage(page) {
    return fetch('/collections.json?limit=250&page=' + page)
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var cols = data.collections || [];
        all = all.concat(cols);
        if (cols.length === 250) return fetchPage(page + 1);
        return all;
      })
      .catch(function() { return all; });
  }
  fetchPage(1).then(function(cols) { allCollections = cols; });
}

function fetchCollectionProducts(handle) {
  var all = [];
  function fetchPage(page) {
    return fetch('/collections/' + handle + '/products.json?limit=250&page=' + page)
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var prods = data.products || [];
        all = all.concat(prods);
        if (prods.length === 250) return fetchPage(page + 1);
        return all;
      })
      .catch(function() { return all; });
  }
  return fetchPage(1).then(function(raw) {
    return normalizeInChunks(raw, 50);
  });
}

function fetchSampleProducts() {
  if (allProducts.length > 0) return Promise.resolve(allProducts);

  var pages = ['/products.json?limit=250&page=1', '/products.json?limit=250&page=2', '/products.json?limit=250&page=3'];

  return Promise.all(pages.map(function(url) {
    return fetch(url).then(function(r) { return r.json(); }).catch(function() { return { products: [] }; });
  })).then(function(results) {
    var raw = [];
    results.forEach(function(d) { raw = raw.concat(d.products || []); });
    return normalizeInChunks(raw).then(function(products) {
      allProducts = products;
      return allProducts;
    });
  });
}

function normalizeProduct(p) {
  if (!p) return null;
  var variant  = (p.variants && p.variants[0]) || {};
  var price    = parseFloat(variant.price || '0');
  var img      = (p.images && p.images[0]) ? p.images[0].src : '';
  var tags     = Array.isArray(p.tags)
    ? p.tags
    : String(p.tags||'').split(',').map(function(t){ return t.trim(); }).filter(Boolean);
  var normTags = tags.map(function(t){ return t.toLowerCase().trim(); });
  var isHidden = HIDDEN_TAGS.some(function(ht){ return normTags.indexOf(ht) !== -1; });
  var isHiddenType = HIDDEN_TYPES.indexOf(String(p.product_type || '').toLowerCase().trim()) !== -1;
  if (isHidden || isHiddenType) return null;
  return {
    id:             p.id,
    title:          p.title || '',
    product_type:   String(p.product_type || '').toLowerCase(),
    price:          price,
    image:          img,
    url:            '/products/' + p.handle,
    variant_id:     variant.id || '',
    handle:         p.handle || '',
    variants_count: (p.variants || []).length,
    tags:           normTags
  };
}

/* â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•
   STEP 1: OCCASION
â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â• */
function buildOccasionDropdown() {
  var drop = document.getElementById('gba-drop-occasion');
  drop.innerHTML = '';
  /* INP fix: build all options in one go using a DocumentFragment
     to avoid repeated reflows. */
  var frag = document.createDocumentFragment();
  ALL_OCCASIONS.forEach(function(key) {
    var cfg     = OCCASION_CONFIG[key]; if (!cfg) return;
    var iconKey = key === 'any' ? 'any-occ' : key;
    var opt     = makeOpt(iconKey, cfg.label, true, function(k, c){ return function(){ onOccasionSelected(k, c.label, c); }; }(key, cfg));
    frag.appendChild(opt);
  });
  drop.appendChild(frag);
}

function onOccasionSelected(val, label, cfg) {
  S.occasion = val;
  markPicked('occasion', val === 'any' ? 'any-occ' : val);
  setLabel('occasion', label, val === 'any' ? 'any-occ' : val);
  closeAll();
  resetStep('recipient'); resetStep('budget'); disableFind();
  stepLoading(true);

  if (val === 'any') {
    fetchSampleProducts().then(function() {
      occPool = applyHiddenTagFilter(allProducts);
      stepLoading(false);
      /* INP fix: yield before building dropdown so paint can happen first */
      return yieldToMain();
    }).then(function() {
      buildRecipientDropdown(); on('recipient');
    });
    return;
  }

  var colKws = cfg.colKeywords || [];

  function colMatchPriority(col) {
    var handle = (col.handle || '').toLowerCase().trim();
    for (var i = 0; i < colKws.length; i++) {
      if (handle === colKws[i].toLowerCase().trim()) return i; // lower index = higher priority
    }
    return -1; // no match
  }

  var matchedCols = allCollections.filter(function(col){ return colMatchPriority(col) !== -1; });
  matchedCols.sort(function(a, b){ return colMatchPriority(a) - colMatchPriority(b); });

  if (matchedCols.length > 0) {
    Promise.all(matchedCols.map(function(col){ return fetchCollectionProducts(col.handle); }))
    .then(function(arrays) {
      var seen = {}, merged = [];
      arrays.forEach(function(arr){ arr.forEach(function(p){ if (!seen[p.id]){ seen[p.id]=true; merged.push(p); } }); });
      occPool = merged;
      stepLoading(false);
      return yieldToMain();
    }).then(function() {
      buildRecipientDropdown(); on('recipient');
    });
  } else {
    fetchSampleProducts().then(function() {
      occPool = applyHiddenTagFilter(allProducts);
      stepLoading(false);
      return yieldToMain();
    }).then(function() {
      buildRecipientDropdown(); on('recipient');
    });
  }
}

function applyHiddenTagFilter(products) {
  return products.filter(function(p) {
    return !HIDDEN_TAGS.some(function(ht){ return p.tags.indexOf(ht) !== -1; });
  });
}

/* â•â•â•â•â•â•â•â•â•â•â•â• RECIPIENT HELPERS â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â• */
function productHasRecipientTag(p, rec) {
  if (rec.val === 'anyone') return true;
  return rec.kws.some(function(kw){
    return p.tags.indexOf(kw.toLowerCase().trim()) !== -1;
  });
}
function productMatchesRecipient(p, rec) {
  if (rec.val === 'anyone') return true;
  var hay = (p.title + ' ' + p.url + ' ' + p.handle + ' ' + p.tags.join(' ')).toLowerCase();
  return rec.kws.some(function(kw){ return hay.indexOf(kw) !== -1; });
}

/* â•â•â•â•â•â•â•â•â•â•â•â• STEP 2: RECIPIENT â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â• */
function buildRecipientDropdown() {
  var drop = document.getElementById('gba-drop-recipient');
  drop.innerHTML = '';
  /* INP fix: pre-compute availability outside the loop, avoid
     repeated .some() calls inside makeOpt (they're O(n) each). */
  var poolHasRecipientTags = occPool.some(function(p){
    return RECIPIENT_OPTIONS.slice(1).some(function(r){ return productHasRecipientTag(p, r); });
  });
  var frag = document.createDocumentFragment();
  RECIPIENT_OPTIONS.forEach(function(rec) {
    var avail;
    if (rec.val === 'anyone')       avail = true;
    else if (!poolHasRecipientTags) avail = false;
    else avail = occPool.some(function(p){ return productHasRecipientTag(p, rec); });
    var opt = makeOpt(rec.val, rec.label, avail, avail ? (function(r){ return function(){ onRecipientSelected(r); }; }(rec)) : null);
    frag.appendChild(opt);
  });
  drop.appendChild(frag);
  rebindTrigger('recipient');
}

function onRecipientSelected(rec) {
  S.recipient = rec;
  markPicked('recipient', rec.val);
  setLabel('recipient', rec.label, rec.val);
  closeAll();

  /* INP fix: defer the filter loop so the label update paints first */
  yieldToMain().then(function() {
    if (rec.val === 'anyone') {
      recPool = occPool.slice();
    } else {
      var poolHasRecipientTags = occPool.some(function(p){
        return RECIPIENT_OPTIONS.slice(1).some(function(r){ return productHasRecipientTag(p, r); });
      });
      if (!poolHasRecipientTags) {
        // no tag data to go on for this occasion pool — don't fake-filter with substrings
        recPool = occPool.slice();
      } else {
        recPool = occPool.filter(function(p){ return productHasRecipientTag(p, rec); });
        if (recPool.length === 0) recPool = occPool.slice();
      }
    }
    resetStep('budget');
    buildBudgetDropdown();
    on('budget');
  });
}

/* â•â•â•â•â•â•â•â•â•â•â•â• STEP 3: BUDGET â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â• */
function buildBudgetDropdown() {
  var drop = document.getElementById('gba-drop-budget');
  drop.innerHTML = '';
  var frag = document.createDocumentFragment();
  BUDGET_OPTIONS.forEach(function(bud) {
    var avail = bud.val === 'anyprice' || recPool.length === 0
      ? true
      : recPool.some(function(p){ return p.price >= bud.min && p.price <= bud.max; });
    var opt = makeOpt(bud.val, bud.label, avail, avail ? (function(b){ return function(){ onBudgetSelected(b); }; }(bud)) : null);
    frag.appendChild(opt);
  });
  drop.appendChild(frag);
  rebindTrigger('budget');
}

function onBudgetSelected(bud) {
  S.budget = bud;
  markPicked('budget', bud.val);
  setLabel('budget', bud.label, bud.val);
  closeAll();
  enableFind();
}

/* â•â•â•â•â•â•â•â•â•â•â•â• FIND & RESULTS â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â•â• */
function bindFind() {
  document.getElementById('gba-btn-find').addEventListener('click', function(){
    if (!S.occasion || !S.recipient || !S.budget) return;
    document.getElementById('gba-loading').style.display = 'block';
    document.getElementById('gba-results').style.display = 'none';
    /* INP fix: use rAF + setTimeout so the loading spinner paints
       before the heavy filter/render work begins. */
    requestAnimationFrame(function() {
      setTimeout(showResults, 50);
    });
  });
}

function showResults() {
  var bud   = S.budget;
  var title = 'Based on your choices we recommend these gifts!';
  if (bud.val === 'anyprice') {
    finalPool = recPool.slice();
  } else {
    finalPool = recPool.filter(function(p){ return p.price >= bud.min && p.price <= bud.max; });
    if (finalPool.length === 0 && recPool.length > 0) {
      finalPool = recPool.slice();
      title = 'Here are our best matches some may be outside your selected budget range.';
    }
  }
  if (finalPool.length === 0 && occPool.length > 0) {
    finalPool = occPool.slice();
    title = 'Here are all available gifts for this occasion!';
  }
  document.getElementById('gba-loading').style.display = 'none';
  document.getElementById('gba-results').style.display = 'block';
  document.getElementById('gba-results-title').textContent = title;
  if (finalPool.length === 0) {
    document.getElementById('gba-grid').style.display  = 'none';
    document.getElementById('gba-empty').style.display = 'block';
    document.getElementById('gba-pages').innerHTML     = '';
  } else {
    document.getElementById('gba-empty').style.display = 'none';
    document.getElementById('gba-grid').style.display  = 'grid';
    renderPage(1);
  }
  scrollTop();
}

/* INP fix: renderPage uses a DocumentFragment and event delegation
   instead of attaching one listener per card button. */
function renderPage(page) {
  var start = (page-1)*PER;
  var items = finalPool.slice(start, start+PER);
  var total = Math.ceil(finalPool.length/PER);
  var grid  = document.getElementById('gba-grid');

  /* Build HTML string (fast) then set once (single reflow). */
  grid.innerHTML = items.map(function(p, i){
    var img = p.image
      ? '<img class="gba-card-img" src="'+esc(p.image)+'" alt="'+esc(p.title)+'" loading="lazy">'
      : '<div class="gba-card-img"></div>';
    var isMulti = (p.variants_count && p.variants_count > 1);
    var btn = isMulti
      ? '<button class="gba-atc gba-quick-add-btn" data-handle="'+esc(p.handle)+'" data-title="'+esc(p.title)+'">'
        +'<span class="gba-atc-spin"></span>'
        +'<svg width="13" height="13" viewBox="0 0 14 14" fill="none" style="margin-right:5px;flex-shrink:0"><path d="M7 1v12M1 7h12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>'
        +'<span class="gba-atc-txt">Quick Add</span>'
        +'</button>'
      : '<button class="gba-atc" data-vid="'+esc(String(p.variant_id||''))+'">'
        +'<span class="gba-atc-spin"></span><span class="gba-atc-txt">Add to Cart</span>'
        +'</button>';
    return '<div class="gba-card" style="animation-delay:'+(i*80)+'ms">'
      +'<a href="'+esc(p.url)+'">'+img
      +'<div class="gba-card-info">'
      +'<div class="gba-card-title">'+esc(p.title)+'</div>'
      +'<div class="gba-card-price">$'+p.price.toFixed(2)+'</div>'
      +'</div></a>'
      +btn
      +'</div>';
  }).join('');

  /* INP fix: single delegated listener on the grid instead of N listeners.
     This replaces the previous per-button addEventListener approach. */
  grid.onclick = function(e) {
    var btn = e.target.closest('.gba-atc');
    if (!btn) return;
    if (btn.classList.contains('gba-quick-add-btn')) {
      var handle = btn.dataset.handle;
      if (handle) openQuickAdd(handle);
    } else {
      addToCart(btn);
    }
  };

  renderPages(page, total);
}

function renderPages(page, total) {
  var el = document.getElementById('gba-pages');
  if (total <= 1) { el.innerHTML = ''; return; }
  var h = '<button class="gba-pg" data-pg="'+(page-1)+'"'+(page===1?' disabled':'')+'>&#8592;</button>';
  function b(n){ h += '<button class="gba-pg'+(n===page?' on':'')+'" data-pg="'+n+'">'+n+'</button>'; }
  function d(){ h += '<button class="gba-pg" disabled>...</button>'; }
  b(1);
  var s=Math.max(2,page-2), e=Math.min(total-1,page+3);
  if(s>2)d(); for(var i=s;i<=e;i++)b(i); if(e<total-1)d();
  if(total>1)b(total);
  h += '<button class="gba-pg" data-pg="'+(page+1)+'"'+(page===total?' disabled':'')+'>&#8594;</button>';
  el.innerHTML = h;
  /* INP fix: delegate pagination clicks one listener, not N. */
  el.onclick = function(e) {
    var btn = e.target.closest('.gba-pg');
    if (!btn || btn.disabled) return;
    var pg = parseInt(btn.dataset.pg, 10);
    if (pg >= 1 && pg <= total) { renderPage(pg); scrollTop(); }
  };
}


function addToCart(btn) {
  if (btn.disabled) return;
  var vid = btn.dataset.vid; if (!vid) return;

  btn.disabled = true;
  btn.classList.add('loading');
  btn.querySelector('.gba-atc-txt').textContent = 'Adding...';

  fetch('/cart/add.js', {
    method:  'POST',
    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    body:    JSON.stringify({ id: parseInt(vid, 10), quantity: 1 })
  })
  .then(function(r) {
    if (!r.ok) return r.json().then(function(e){ throw e; });
    btn.classList.remove('loading');
    btn.classList.add('ok');
    btn.querySelector('.gba-atc-txt').textContent = 'Added!';
    refreshCart();
    setTimeout(function() {
      btn.disabled = false;
      btn.classList.remove('ok');
      btn.querySelector('.gba-atc-txt').textContent = 'Add to Cart';
    }, 2200);
  })
  .catch(function(err) {
    btn.disabled = false;
    btn.classList.remove('loading');
    btn.querySelector('.gba-atc-txt').textContent = 'Add to Cart';
    alert((err && err.description) ? err.description : 'Could not add item.');
  });
}


function formatCartMoney(cents) {
  try {
    var fmt = (window.themeHDN && window.themeHDN.settings && window.themeHDN.settings.moneyFormat)
      ? window.themeHDN.settings.moneyFormat : '${{amount}}';
    return fmt.replace(/\{\{\s*amount[\w]*\s*\}\}/, (cents / 100).toFixed(2));
  } catch(e) { return '$' + (cents / 100).toFixed(2); }
}

function updateBadge(n, totalFormatted) {
  var hdtCart = document.querySelector('hdt-cart-drawer');
  if (hdtCart) hdtCart.setAttribute('data-count', n);
  document.querySelectorAll('hdt-cart-count').forEach(function(el) {
    el.textContent = n;
    if (n > 0) { el.removeAttribute('hidden'); el.style.display = ''; }
    else { el.style.display = 'none'; }
  });
  if (totalFormatted) {
    document.querySelectorAll('hdt-cart-total').forEach(function(el) { el.textContent = totalFormatted; });
  }
  var sels = ['.hdt-mini-cart__count','.hdt-header__cart-count','[data-cart-count]','[data-header-cart-count]',
    '#cart-icon-bubble','.cart-count-bubble span','.t4s-cart-count','.t4s-cart-icon__count'];
  sels.forEach(function(s) {
    document.querySelectorAll(s).forEach(function(el) {
      el.textContent = n;
      if (n > 0) { el.removeAttribute('hidden'); el.style.display = ''; }
    });
  });
}

function openHDTCart() {
  var hdtCart = document.querySelector('hdt-cart-drawer');
  if (hdtCart && typeof hdtCart.open === 'function') { hdtCart.open(); return; }
  var triggerSels = ['[aria-controls="CartDrawer"]','[data-cart-drawer-trigger]',
    '.hdt-header__cart','.hdt-header__icon--cart','button[data-cart]',
    'a[href="/cart"].hdt-header__icon','.t4s-site-nav__cart > a',
    '[data-t4s-open-quickcart]','[data-open-quickcart]','.t4s-cart-icon a'];
  for (var i = 0; i < triggerSels.length; i++) {
    var el = document.querySelector(triggerSels[i]);
    if (el && !el.closest('#CartDrawer') && !el.closest('hdt-cart-drawer')) { el.click(); return; }
  }
  document.dispatchEvent(new CustomEvent('hdt:cart:open', { bubbles: true }));
}

function refreshCart() {
  fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      updateBadge(cart.item_count, formatCartMoney(cart.total_price));
      var hdtCart = document.querySelector('hdt-cart-drawer');
      if (!hdtCart) { openHDTCart(); return; }
      if (typeof hdtCart.renderContents === 'function') { hdtCart.renderContents(); openHDTCart(); return; }
      if (typeof hdtCart.refresh === 'function') { hdtCart.refresh(); openHDTCart(); return; }
      var sectionId = hdtCart.getAttribute('section-id') || 'cart-drawer';
      fetch('/?sections=' + sectionId, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function(r) { return r.json(); })
        .then(function(data) {
          var html = data[sectionId] || null;
          if (html) {
            var doc   = new DOMParser().parseFromString(html, 'text/html');
            var fresh = doc.querySelector('cart-items-component');
            var live  = document.querySelector('cart-items-component');
            if (fresh && live) live.replaceWith(fresh);
          }
          openHDTCart();
        })
        .catch(function() { openHDTCart(); });
    })
    .catch(function() { openHDTCart(); });
}


function bindRestart() {
  document.querySelectorAll('.gba-btn-restart').forEach(function(btn){
    btn.addEventListener('click', function(){
      S = { occasion:null, recipient:null, budget:null };
      occPool=[]; recPool=[]; finalPool=[];
      ['occasion','recipient','budget'].forEach(resetStep);
      on('occasion'); disableFind();
      document.getElementById('gba-results').style.display = 'none';
      document.getElementById('gba-loading').style.display = 'none';
      scrollTop();
    });
  });
}

function makeOpt(iconKey, label, available, clickFn) {
  var div       = document.createElement('div');
  div.className = 'gba-opt' + (available ? '' : ' gba-dim');
  div.dataset.val = iconKey;
  addIcon(div, iconKey);
  div.appendChild(document.createTextNode(label));
  if (clickFn) div.addEventListener('click', clickFn);
  return div;
}

function addIcon(el, key) {
  if (!ICONS[key] || el.querySelector('.gba-ico')) return;
  var sp = document.createElement('span');
  sp.className = 'gba-ico';
  sp.innerHTML = ICONS[key];
  el.insertBefore(sp, el.firstChild);
}

function rebindTrigger(key) {
  // No-op — bindTrigger() already attached a permanent listener
  // for this trigger in init(), so nothing needs re-binding.
}

function bindTrigger(key) {
  var trig = document.getElementById('gba-trig-' + key);
  var cs   = document.getElementById('gba-cs-' + key);
  trig.addEventListener('click', function(e){
    e.stopPropagation();
    if (cs.classList.contains('gba-off')) return;
    var open = cs.classList.contains('gba-open');
    closeAll();
    if (!open) cs.classList.add('gba-open');
  });
}

function markPicked(key, val) {
  var drop = document.getElementById('gba-drop-' + key);
  if (drop) drop.querySelectorAll('.gba-opt').forEach(function(o){
    o.classList.toggle('gba-sel', o.dataset.val === val);
  });
  var cs = document.getElementById('gba-cs-' + key);
  if (cs) cs.classList.add('gba-picked');
}

function setLabel(key, text, iconKey) {
  var lbl = document.getElementById('gba-lbl-' + key);
  if (!lbl) return;
  var svg = ICONS[iconKey] || '';
  lbl.innerHTML = svg
    ? '<span class="gba-trico">' + svg + '</span>' + esc(text)
    : '';
  if (!svg) lbl.textContent = text;
  lbl.classList.add('v');
}

function on(key) {
  var cs = document.getElementById('gba-cs-' + key);
  if (cs) cs.classList.remove('gba-off');
}

function resetStep(key) {
  var cs       = document.getElementById('gba-cs-' + key);
  var lbl      = document.getElementById('gba-lbl-' + key);
  var drop     = document.getElementById('gba-drop-' + key);
  var defaults = { occasion:'Occasion', recipient:'Recipient', budget:'Budget' };
  if (cs)   { cs.classList.add('gba-off'); cs.classList.remove('gba-picked','gba-open'); }
  if (lbl)  { lbl.textContent = defaults[key]; lbl.classList.remove('v'); }
  if (drop) { drop.querySelectorAll('.gba-opt').forEach(function(o){ o.classList.remove('gba-sel'); }); }
}

function enableFind()  { var b=document.getElementById('gba-btn-find'); if(b){b.disabled=false;b.classList.remove('gba-off');} }
function disableFind() { var b=document.getElementById('gba-btn-find'); if(b){b.disabled=true; b.classList.add('gba-off');} }

function closeAll() {
  ['occasion','recipient','budget'].forEach(function(k){
    var cs=document.getElementById('gba-cs-'+k); if(cs) cs.classList.remove('gba-open');
  });
}

function stepLoading(show) {
  document.getElementById('gba-step-loading').style.display = show ? 'block' : 'none';
  if (show) {
    ['recipient','budget'].forEach(function(k){
      var cs=document.getElementById('gba-cs-'+k); if(cs) cs.classList.add('gba-off');
    });
  }
}

function esc(s) {
  return String(s)
    .replace(/&/g,'&amp;').replace(/</g,'&lt;')
    .replace(/>/g,'&gt;').replace(/"/g,'&quot;');
}

function scrollTop() {
  var w = document.querySelector('.gba-wrapper');
  if (w) window.scrollTo({ top: w.offsetTop - 20, behavior:'smooth' });
}

/* 
   QUICK ADD MODAL
 */
var QA = { overlay:null, modal:null, product:null, selectedOptions:{}, selectedVariant:null };

function initQuickAdd() {
  QA.overlay = document.getElementById('gba-qa-overlay');
  QA.modal   = document.getElementById('gba-qa-modal');
  document.getElementById('gba-qa-close').addEventListener('click', closeQuickAdd);
  QA.overlay.addEventListener('click', function(e){ if (e.target === QA.overlay) closeQuickAdd(); });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape') closeQuickAdd(); });
  document.getElementById('gba-qa-atc').addEventListener('click', modalAddToCart);
}

function openQuickAdd(handle) {
  QA.product = null; QA.selectedOptions = {}; QA.selectedVariant = null;
  document.getElementById('gba-qa-loading').style.display = 'flex';
  document.getElementById('gba-qa-content').style.display = 'none';
  document.getElementById('gba-qa-main-img').src = '';
  document.getElementById('gba-qa-thumbs').innerHTML = '';
  QA.overlay.classList.add('gba-qa-open');
  QA.overlay.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';

  fetch('/products/' + handle + '.js')
    .then(function(r){ return r.json(); })
    .then(function(product){ QA.product = product; populateModal(product); })
    .catch(function(){ closeQuickAdd(); alert('Could not load product details.'); });
}

function populateModal(product) {
  var rawImages = product.images || [];
  var imageUrls = rawImages.map(function(img){
    return typeof img === 'string' ? img : (img && img.src ? img.src : '');
  }).filter(Boolean);
  if (imageUrls.length === 0 && product.featured_image) {
    var fi = product.featured_image;
    imageUrls = [typeof fi === 'string' ? fi : (fi && fi.src ? fi.src : '')];
  }

  var mainImgEl = document.getElementById('gba-qa-main-img');
  var thumbsEl  = document.getElementById('gba-qa-thumbs');
  var firstUrl  = imageUrls[0] || '';
  mainImgEl.src = firstUrl ? (firstUrl + (firstUrl.indexOf('?') !== -1 ? '&' : '?') + 'width=800') : '';
  mainImgEl.alt = product.title || '';

  thumbsEl.innerHTML = '';
  var thumbFrag = document.createDocumentFragment();
  imageUrls.slice(0, 8).forEach(function(url, idx){
    var th = document.createElement('img');
    th.className = 'gba-qa-thumb' + (idx === 0 ? ' active' : '');
    th.src = url; th.alt = (product.title || '') + ' ' + (idx + 1); th.loading = 'lazy';
    th.addEventListener('click', function(){
      mainImgEl.style.opacity = '0';
      setTimeout(function(){ mainImgEl.src = url; mainImgEl.style.opacity = '1'; }, 120);
      thumbsEl.querySelectorAll('.gba-qa-thumb').forEach(function(t){ t.classList.remove('active'); });
      th.classList.add('active');
    });
    thumbFrag.appendChild(th);
  });
  thumbsEl.appendChild(thumbFrag);

  var productUrl = '/products/' + product.handle;
  document.getElementById('gba-qa-title').textContent = product.title;
  document.getElementById('gba-qa-title-link').href   = productUrl;
  document.getElementById('gba-qa-view-link').href    = productUrl;
  document.getElementById('gba-qa-desc').innerHTML    = product.description || '<em style="color:#aaa">No description available.</em>';

  var variants = product.variants || [];
  var options  = product.options  || [];
  var firstAvail = variants.find(function(v){ return v.available; }) || variants[0];
  if (firstAvail) {
    options.forEach(function(opt, i){ QA.selectedOptions[opt.name] = firstAvail['option' + (i + 1)]; });
  }
  buildVariantPicker(variants, options);
  syncModalVariant();

  document.getElementById('gba-qa-loading').style.display = 'none';
  var c = document.getElementById('gba-qa-content');
  c.style.display = 'flex'; c.style.flexDirection = 'column'; c.style.flex = '1';
}

function buildVariantPicker(variants, options) {
  var container = document.getElementById('gba-qa-options');
  container.innerHTML = '';
  if (options.length === 1 && options[0].name === 'Title' && variants.length === 1) return;

  var frag = document.createDocumentFragment();
  options.forEach(function(opt, optIdx){
    var group = document.createElement('div'); group.className = 'gba-qa-opt-group';
    var lbl   = document.createElement('span'); lbl.className = 'gba-qa-opt-label';
    lbl.dataset.optName = opt.name;
    lbl.innerHTML = esc(opt.name) + ': <em>' + esc(QA.selectedOptions[opt.name] || '') + '</em>';
    group.appendChild(lbl);

    var pills = document.createElement('div'); pills.className = 'gba-qa-pills';
    var seen  = {};
    (opt.values || []).forEach(function(val){
      if (seen[val]) return; seen[val] = true;
      var hasAvail = variants.some(function(v){ return v['option'+(optIdx+1)] === val && v.available; });
      var pill = document.createElement('button');
      pill.type = 'button'; pill.textContent = val;
      pill.className = 'gba-qa-pill' + (QA.selectedOptions[opt.name] === val ? ' selected' : '') + (hasAvail ? '' : ' sold-out');
      pill.dataset.optName = opt.name; pill.dataset.optValue = val;
      if (hasAvail) {
        pill.addEventListener('click', function(){
          QA.selectedOptions[opt.name] = val;
          pills.querySelectorAll('.gba-qa-pill').forEach(function(p){ p.classList.remove('selected'); });
          pill.classList.add('selected');
          lbl.innerHTML = esc(opt.name) + ': <em>' + esc(val) + '</em>';
          syncModalVariant();
        });
      }
      pills.appendChild(pill);
    });
    group.appendChild(pills);
    frag.appendChild(group);
  });
  container.appendChild(frag);
}

function syncModalVariant() {
  if (!QA.product) return;
  var variants = QA.product.variants || [];
  var options  = QA.product.options  || [];
  var matched  = variants.find(function(v){
    return options.every(function(opt, i){ return v['option'+(i+1)] === QA.selectedOptions[opt.name]; });
  }) || variants[0];
  QA.selectedVariant = matched;

  if (matched && matched.featured_image) {
    var fi = matched.featured_image;
    var varImgUrl = typeof fi === 'string' ? fi : (fi && fi.src ? fi.src : '');
    if (varImgUrl) {
      var mainImgEl = document.getElementById('gba-qa-main-img');
      var thumbsEl  = document.getElementById('gba-qa-thumbs');
      mainImgEl.style.opacity = '0';
      setTimeout(function(){ mainImgEl.src = varImgUrl; mainImgEl.style.opacity = '1'; }, 130);
      var baseFi = varImgUrl.split('?')[0];
      thumbsEl.querySelectorAll('.gba-qa-thumb').forEach(function(th){
        if ((th.src || '').split('?')[0] === baseFi) {
          thumbsEl.querySelectorAll('.gba-qa-thumb').forEach(function(t){ t.classList.remove('active'); });
          th.classList.add('active');
        }
      });
    }
  }

  var priceEl = document.getElementById('gba-qa-price');
  if (matched) priceEl.textContent = '$' + (parseFloat(matched.price) / 100).toFixed(2);

  var atcBtn = document.getElementById('gba-qa-atc');
  if (matched && matched.available) {
    atcBtn.disabled = false;
    atcBtn.querySelector('.gba-atc-txt').textContent = 'Add to Cart';
  } else {
    atcBtn.disabled = true;
    atcBtn.querySelector('.gba-atc-txt').textContent = 'Sold Out';
  }
}

function closeQuickAdd() {
  if (!QA.overlay) return;
  QA.overlay.classList.remove('gba-qa-open');
  QA.overlay.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
}

function modalAddToCart() {
  if (!QA.selectedVariant || !QA.selectedVariant.id) return;
  var btn = document.getElementById('gba-qa-atc');
  if (btn.disabled) return;
  btn.disabled = true; btn.classList.add('loading');
  btn.querySelector('.gba-atc-txt').textContent = 'Adding...';

  fetch('/cart/add.js', {
    method:  'POST',
    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    body:    JSON.stringify({ id: parseInt(QA.selectedVariant.id, 10), quantity: 1 })
  })
  .then(function(r) {
    if (!r.ok) return r.json().then(function(e){ throw e; });
    btn.classList.remove('loading'); btn.classList.add('ok');
    btn.querySelector('.gba-atc-txt').textContent = 'Added!';
    refreshCart();
    setTimeout(function(){
      closeQuickAdd();
      setTimeout(function(){
        btn.disabled = false; btn.classList.remove('ok');
        btn.querySelector('.gba-atc-txt').textContent = 'Add to Cart';
      }, 300);
    }, 900);
  })
  .catch(function(err){
    btn.disabled = false; btn.classList.remove('loading');
    btn.querySelector('.gba-atc-txt').textContent = 'Add to Cart';
    alert((err && err.description) ? err.description : 'Could not add item.');
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function(){ init(); initQuickAdd(); });
} else {
  init(); initQuickAdd();
}

}());
